module.exports = __webpack_public_path__ + "img/product.3fa4baea.svg";